const DEFAULT_GOLD_COMPANY_ID = '00000000-0000-0000-0000-000000000000';
const DEFAULT_SOURCE_LOCALE_CODE = 'en-US';

module.exports = {
    DEFAULT_GOLD_COMPANY_ID,
    DEFAULT_SOURCE_LOCALE_CODE
};